import { useMutation } from "react-query";

import { useApiClient } from "api/useApiClient";
import { reportError } from "utils/errorReporting";

import type { EditExerciseFormData, ExerciseListItem } from "../schemas/exercises";

import { createExercisePayload, createLevelPayload, createTranslationPayload } from "./utils";

export const usePutExercise = () => {
  const client = useApiClient();

  return useMutation<{ tempExercise: ExerciseListItem }, Error, EditExerciseFormData>(async args => {
    try {
      const { exerciseID, exerciseLevelID, exerciseLevelTranslationID } = args;
      const exercisePayload = createExercisePayload(args);
      const exerciseResponse = await client.putExercise({ exerciseID, data: exercisePayload });

      const { levels } = args;
      const level = levels[0];

      const levelPayload = createLevelPayload(level);
      const levelResponse = await client.putExerciseLevel({ exerciseID, exerciseLevelID, data: levelPayload });

      const translationPayload = createTranslationPayload(level);
      const translationResponse = await client.putExerciseLevelTranslation({
        exerciseID,
        exerciseLevelID,
        exerciseLevelTranslationID,
        data: translationPayload,
      });

      const tempExercise: ExerciseListItem = {
        ...exerciseResponse,
        levels: [{ ...levelResponse, ...translationResponse }],
        exercise_id: exerciseResponse.id,
        deleted_at: null,
        number_of_levels: 1,
      };
      return { tempExercise };
    } catch (error) {
      reportError("Failed to create exercise", new Error(JSON.stringify({ error, variables: args })));
      throw error;
    }
  });
};
